import React from "react";
import { useStyles } from "./SkeletonStyles";

export const ItemCardSkeleton = () => {
  const styles = useStyles();

  return (
    <div className={styles.cardContainer}>
      <div className={styles.photo} />
      <div className={styles.textContainer}>
        <div className={styles.title} />
        <div className={styles.description} />
        <div className={styles.description} />
      </div>
    </div>
  );
};
